import { confetti } from "tsparticles-confetti";

export const ConfettiTypes = {
  petalShower: "petalShower",
  default: "default",
  rosePetals: "rosePetals",
  marigoldPetals: "marigoldPetals",
};

function randomInRange(min, max) {
  return Math.random() * (max - min) + min;
}

// A single rose petal as an image shape, one per shade, so the burst is all roses.
const PETAL_FILLS = ["#9b1b30", "#b3243b", "#c9364d", "#d9566a", "#e8798a"];
const petalImage = (fill) => ({
  src: `data:image/svg+xml;utf8,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><path d="M20 2C32 8 36 22 24 37C22 39 18 39 16 37C4 22 8 8 20 2Z" fill="${fill}"/><path d="M20 6C21 16 21 26 20 36" stroke="#fff" stroke-opacity=".25" stroke-width="1.2" fill="none"/></svg>`,
  )}`,
  width: 40,
  height: 40,
});

// Marigold, haldi and rani-pink petals, for the mela-coloured Utsav theme.
const MARIGOLD_FILLS = ["#ec7a0c", "#f79a17", "#ffcd2e", "#d81b60", "#f06292"];

const confettiOptions = {
  [ConfettiTypes.default]: {
    particleCount: 100,
    spread: 70,
    origin: { y: 0.7 },
  },
  [ConfettiTypes.rosePetals]: {
    particleCount: 60,
    spread: 80,
    startVelocity: 32,
    gravity: 0.5,
    decay: 0.92,
    drift: 0.2,
    ticks: 260,
    scalar: 2,
    origin: { y: 0.7 },
    shapes: ["image"],
    shapeOptions: { image: PETAL_FILLS.map(petalImage) },
  },
  [ConfettiTypes.marigoldPetals]: {
    particleCount: 70,
    spread: 85,
    startVelocity: 32,
    gravity: 0.5,
    decay: 0.92,
    drift: 0.2,
    ticks: 260,
    scalar: 1.8,
    origin: { y: 0.7 },
    shapes: ["image"],
    shapeOptions: { image: MARIGOLD_FILLS.map(petalImage) },
  },
  [ConfettiTypes.petalShower]: {
    angle: 90,
    count: 200,
    decay: 0.9,
    gravity: randomInRange(0.4, 0.6),
    scalar: 1,
    drift: randomInRange(-0.4, 0.4),
    ticks: 200,
    colors: ["#f8d7da", "#fbeaea", "#f6e6e6", "#fff5f5"],
    zIndex: 100,
    disableForReducedMotion: true,
    spread: 180,
    particleCount: 1,
    origin: { y: -0.1 },
    startVelocity: -35,
    shapes: ["circle"],
  },
};

export const useConfetti = () => {
  const showConfetti = (confettiType) => {
    (async () => {
      await confetti("tsparticles", confettiOptions[confettiType]);
    })();
  };

  return { showConfetti };
};
